import { divIcon } from "leaflet";
import React from "react";
import { Marker, Tooltip } from "react-leaflet";

const PlatonPoints = React.memo(({ platonPoints }) => {
    const icon = divIcon({ className: "map-icon--platon-points", iconSize: [22, 22] });
    return platonPoints.map((el, index) => <PlatonPoint key={index} icon={icon} item={el} />);
});

const PlatonPoint = (props) => {
    const {
        item: { geozone, name },
        icon,
    } = props;
    if (!geozone?.location?.coordinates) {
        return null;
    }
    return (
        <Marker position={[...geozone.location.coordinates].reverse()} icon={icon}>
            <Tooltip direction="top">
                <div>{name}</div>
            </Tooltip>
        </Marker>
    );
};

const MemoizedPlatonPoints = (props) => <PlatonPoints {...props} />;

export default MemoizedPlatonPoints;
